
/**
 * 新版自选股接口
 * 
 */

import fingerprint from '../browser_fingerprint'
import cookie from '../cookie'
import user from '../user'


let apiurl = '//myfavor.eastmoney.com/v4/' //正式环境
let appkey = 'a7c4e1aaac05b74fb70daed9e24b7ea6'
let ut = "f057cbcbce2a86e2866ab8877db1d059"

// 测试环境
if(window.location.search.indexOf("env=test") > -1){
  apiurl = '//myfavor-zp-uat.eastmoney.com/v4/'
  appkey = 'a7c4e1aaac05b74fb70daed9e24b7ea6'
}


if(user.get() == null){
  apiurl += 'anonymwapouter/'
}
else{
  apiurl += 'wapouter/'
} 

// let oldapiurl = '//myfavor1.eastmoney.com/' //老接口

// if(user.get() == null){
//   oldapiurl += 'mystock_anonym'
// }
// else{
//   oldapiurl += 'mystock'
// } 

export default {
  /**
   * 获取自选股接口通用参数
   */
  async getParams():Promise<string>{
    if(user.get() == null){
      let fp = await fingerprint.get()
      return `appkey=${appkey}&bid=${fp}`
    }
    else{
      return `appkey=${appkey}`
    }
  },
  /**
   * 获取列表信息
   */
  async groupList(){
    let params = await this.getParams()
    // //老接口
    // let olddata = await $.ajax({
    //   url: `${oldapiurl}?f=gg&cb=?`,
    //   type: 'GET',
    //   dataType: 'jsonp'
    // })
    

    return $.ajax({
      url: `${apiurl}ggdefstkinfos?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {

      }
    })
    .then(function(json) {
      var returnobj = {
        re: true,
        message: '',
        result: [],
        default_group:[]
      }
      if(json.state == 0 && json.data && json.data.ginfolist instanceof Array){

        // try {
        //   // //新老匹配
        //   // if(olddata.result == 1){
        //   //   let oldlist:Array<any> = []
        //   //   Object.keys(olddata.data).forEach((v:any)=>{
        //   //     if(v != 'order'){
        //   //       oldlist.push({
        //   //         gid: v,
        //   //         gname: olddata.data[v][0]
        //   //       })              
        //   //     }
        //   //   })
            
            
        //     // json.data.ginfolist.forEach((v:any)=>{
        //     //   v.old_gid = oldlist.find(v2=>{
        //     //     return v2.gname == v.gname
        //     //   }).gid
        //     // })
        //   }          
        // } catch (error) {
          
        // }

        returnobj.re = true
        returnobj.result = json.data.ginfolist

        if(json?.data?.defstkinfolist && json.data.defstkinfolist instanceof Array){
          returnobj.default_group = json.data.defstkinfolist.map((v:any)=>{
            return v.security.substring(0, v.security.lastIndexOf('$')).replace('$', '.')
          })
        }
      }
      else{
        returnobj.re = false
        returnobj.message = json.message
      }
      return returnobj
    })
  },

  /**
   * 检测是否已经加自选
   */
  async checkHasAdd(code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}gsaandcheck?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true,
          result: back.data.check
        }
      }
      else{
        return {
          re: true,
          result: false
        }
      }
    })
  },

  /**
   * 根据列表id获取列表自选股
   */
  async groupStockByID(groupid:string){
    let params = await this.getParams()
    return $.ajax({
      url: `${apiurl}gstkinfos?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
      }
    })
    .then(function(json) {   
      // console.info(json,'json')
      if(json.state == 0 && json.data.stkinfolist?.length > 0){
        let backarray = json.data.stkinfolist.map(function(v:any){
          v.updatetime = v.updatetime.toString()
          var temp = {
            code: v.security.substring(0, v.security.lastIndexOf('$')).replace('$', '.'),
            star: v.star,
            note: v.note || null,
            hasnote: (v.note == undefined)?false:true
          }
          if(temp.note != null){
            temp.note.addtime = v.updatetime.substring(0,4) + '-' + v.updatetime.substring(4,6) + '-' + v.updatetime.substring(6,8)
            temp.note.addprice = v.price
            temp.note.Count = parseFloat(temp.note.Count)
            temp.note.BrokerageFee = parseFloat(temp.note.BrokerageFee)
            temp.note.Factorage = parseFloat(temp.note.Factorage)
            temp.note.Price = parseFloat(temp.note.Price)
            temp.note.StampDuty = parseFloat(temp.note.StampDuty)            
          }
          else{
            //给没有笔记的股票补充数据
            temp.note = {
              BrokerageFee: 0,
              Count: 0,
              Date: "",
              Desc: "",
              Factorage: 0,
              Price: 0,
              StampDuty: 0,
              StopLossPrice: 0,
              TargetPrice: 0,
              // TransactionDate: 20200528152118,
              addprice: v.price,
              addtime: v.updatetime.substring(0,4) + '-' + v.updatetime.substring(4,6) + '-' + v.updatetime.substring(6,8)
            }
          }
          return temp
        })
        return {
          re: true,
          result: backarray
        }
      }
      else if(json.state == 0 && json.data.stkinfolist.length == 0){
        return {
          re: true,
          result: []
        }
      }
      else{
        return {
          re: false,
          message: json.message
        }
      }
    })
  },
  /**
   * 加自选
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async addStock(groupid:string, code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}as?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  }, 

  /**
   * 加默认分组自选
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async addDefaultStock(code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}asz?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },   
   
  /**
   * 删除自选
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async deleteStock(groupid:string, code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}ds?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },  

  /**
   * 删除默认分组自选
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async deleteDefaultStock(code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}dsz?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },    

  /**
   * 批量删除自选股
   * @param {*} groupid 组合id
   * @param {*} codes 股票代码列表
   */
  async batchDeleteStock(groupid:string, codes:string|Array<string>){
    let params = await this.getParams()
    var codes_str = ''
    if (codes instanceof Array) {
      codes_str = codes.map(function(v){
        return v.replace('.', '$')
      }).join(',')
    }
    else{
      codes_str = codes.split(',').map(function(v){
        return v.replace('.', '$')
      }).join(',')      
    }

    return $.ajax({
      url: `${apiurl}dslot?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        scs: codes_str
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })

  },  
  /**
   * 批量删除自选股 post
   * @param {*} groupid 组合id
   * @param {*} codes 股票代码列表
   */
  async batchDeleteStock_post(groupid:string, codes:string|Array<string>){
    let params = await this.getParams()
    var codes_str = ''
    if (codes instanceof Array) {
      codes_str = codes.map(function(v){
        return v.replace('.', '$')
      }).join(',')
    }
    else{
      codes_str = codes.split(',').map(function(v){
        return v.replace('.', '$')
      }).join(',')      
    }

    return await $.ajax({
      url: `${apiurl}dslot?${params}`,
      type: "post",
      crossDomain: true,
      xhrFields: {
          withCredentials: true 
      },
      data: JSON.stringify({
        g: groupid,
        scs: codes_str
      })
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })

  },  
  /**
   * 批量移动自选股
   * @param {*} groupid 源组合id
   * @param {*} togroupid 目标组合id
   * @param {*} codes 股票代码列表
   */
  async batchMoveStock(groupid:string, togroupid:string, codes:string|Array<string>){
    let params = await this.getParams()
    var codes_str = ''
    if (codes instanceof Array) {
      codes_str = codes.map(function(v){
        return v.replace('.', '$')
      }).join(',')
    }
    else{
      codes_str = codes.split(',').map(function(v){
        return v.replace('.', '$')
      }).join(',')      
    }

    return $.ajax({
      url: `${apiurl}ms?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g1: groupid,
        g: togroupid,
        scs: codes_str
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },     
  /**
   * 置顶
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async setTop(groupid:string, code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}has?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true,
          message: ""
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },  
  /**
   * 取消置顶
   * @param {*} groupid 组合id
   * @param {*} code 股票代码
   */
  async cancelTop(groupid:string, code:string){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}hcs?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        sc: code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },  
  /**
   * 修改分组名称
   * @param {*} groupid 组合id
   * @param {*} groupname 组合名称
   */
  async editGroupName(groupid:string, groupname:string){
    let params = await this.getParams()
    return $.ajax({
      url: `${apiurl}mg?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid,
        gn: groupname
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },   
  /**
   * 新增分组
   * @param {*} groupname 组合名称
   */
  async addGroup(groupname:string){
    let params = await this.getParams()
    return $.ajax({
      url: `${apiurl}ag?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        gn: groupname
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true,
          result:{
            gid: back.data.gid,
            gname: back.data.gname
          }
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },   
  /**
   * 删除分组
   * @param {*} groupid 组合id
   */
  async deleteGroup(groupid:string){
    let params = await this.getParams()
    return $.ajax({
      url: `${apiurl}dg?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        g: groupid
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },    
  /**
   * 修改笔记
   * @param {*} code 
   * @param {*} groupid 
   * @param {*} paramsobj 
   */
  async editNote(code:string, groupid:string, paramsobj:any){
    let params = await this.getParams()
    code = code.replace('.', '$')
    return $.ajax({
      url: `${apiurl}bs?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: $.extend({
        sc: code,
        g: groupid
      }, paramsobj)
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },

  /**
   * 组内移动股票
   * @param groupid 组合id
   * @param code 股票code
   * @param pre_code 前一个code
   * @param next_code 后一个code
   */
  async groupMoveStock(groupid:string, code:string, pre_code:string, next_code:string){
    let params = await this.getParams();
    code = code.replace('.', '$');
    pre_code = pre_code.replace('.', '$');
    next_code = next_code.replace('.', '$');

    return $.ajax({
      url: `${apiurl}ss?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        sc: code,
        g: groupid,
        sc1: pre_code,
        sc2: next_code
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })
  },  

  /**
   * 批量更新次序
   * @param {*} groupid 
   * @param {*} codes 
   * @param {*} topcodes 
   */ 
  async batchEditSort(groupid:string, codes:string|Array<string>, topcodes:string|Array<string>){
    let params = await this.getParams()
    var codes_str = ''
    if (codes instanceof Array) {
      codes_str = codes.map(function(v){
        return v?.replace('.', '$')
      }).join(',')
    }
    else{
      codes_str = codes.split(',').map(function(v){
        return v?.replace('.', '$')
      }).join(',')      
    }

    var codes_str2 = ''
    if (topcodes instanceof Array) {
      codes_str2 = topcodes.map(function(v){
        return v?.replace('.', '$')
      }).join(',')
    }
    else{
      codes_str2 = topcodes.split(',').map(function(v){
        return v?.replace('.', '$')
      }).join(',')      
    }

    return $.ajax({
      url: `${apiurl}uslot?${params}&cb=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        scs: codes_str,
        topscs: codes_str2,
        g: groupid
      }
    }).then(function(back){
      if(back.state == 0){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: back.message
        }
      }
    })

    // return $.ajax({
    //   url: './api/zxg/new_batchedit',
    //   type: 'POST',
    //   dataType: 'json',
    //   cache: false,
    //   data: {
    //     groupid: groupid,
    //     topcodes: codes_str2,
    //     codes: codes_str
    //   }
    // })
  },
  /**
   * 根据分组id 获取对应股票的新闻或者公告
   * @param groupid 
   * @param type  类别 1 新闻 2 公告
   * @param condition
   */
  async getStockNewsOrNoticeByGroupID(groupid:string, type:number, condition:string):Promise<null|{
    condition:string,
    news: Array<{
      articleTagMarket: string,
      code: string,
      commentCount: number,
      infoCode: string,
      infoType: number,
      market: number,
      securityCode: string,
      securityName: string,
      source: string,
      title: string,
      updateTime: number,
    }>
  }>{

    let stocks = await this.groupStockByID(groupid)

    //处理股票列表 只要沪深A股
    if(stocks?.result?.length > 200){
      stocks.result = stocks.result.slice(0,199)
    }

    let dealstocks = stocks.result.slice(0,199).map((v: any)=>v.code).filter((v: any)=>{
      return v.indexOf('0.') === 0 || v.indexOf('1.') === 0 
    })

    let stocks_str = '' //接口需要的代码字符串 例如：300059_0,000001_0
    stocks_str = dealstocks.map((v: string)=>{
      if(v.indexOf('0.') === 0){
        return v.substring(2) + '_0'
      }
      else if(v.indexOf('1.') === 0){
        return v.substring(2) + '_1'
      }
    }).join(',')

    return $.ajax({
      url: 'https://emdcadvise.eastmoney.com/infoAdviseService?callback=?',
      type: 'GET',
      dataType: 'jsonp',
      data: {
        data: JSON.stringify({
          "args": {
              "securities": stocks_str, 
              "infoType": type, 
              "pageSize": 20,
              "condition": condition
          }, 
          "method": "advise.portfolioInfo", 
          "appKey": "wapnew", 
          "client": "wap",
          "timestamp": Date.now()
        })
      }
    }).then(v=>{
      if(v.code == 0){
        return {
          condition: v.data.condition,
          news: v.data.items
        }        
      }else{
        return null
      }
    })
  }
      
}